import { Component, HostListener } from '@angular/core';
import { CXoneAcdClient, CXoneVoiceContact } from '@nice-devone/acd-sdk';
import {
  AgentSessionStatus,
  CXonePopUrl,
  CXoneClientData,
} from '@nice-devone/common-sdk';
import { CXoneClient } from '@nice-devone/agent-sdk';
import { CxOneUtils } from 'src/app/data/CXOne/util/CxOneUtils';
import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { Subject, takeUntil } from 'rxjs';
import { LoggerService } from 'src/app/core/services/logger.service';
import { LoginService } from 'src/app/core/services/login.service';
import { SdkAcdAgent } from 'src/app/data/CXOne/sdk-acd/sdk-acd.service';
import { NiceSdkAuthenticationService } from 'src/app/data/CXOne/sdk-auth/nice-sdk-authentication.service';
import {
  EventType,
  SdkDigitalService,
} from 'src/app/data/CXOne/sdk-digital/sdk-digital.service';
import { DynamicsCivicsV2Service } from 'src/app/data/Dynamics/civics-v2/dynamics-civics-v2.service';
import { TemplateValuesChannelProvider } from 'src/app/data/Dynamics/civics/dynamics-civics.service';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { SendReloadScreenSignalService } from 'src/app/shared/services/sendReloadScreenSignalService';
import { environment } from 'src/environments/environment';
import { CXoneDigitalContact } from '@nice-devone/digital-sdk';
import {
  ContactCenterMainService,
  TemplateValuesChannelProviders,
} from 'src/app/data/CXOne/services/main/contact-center-main.service';
import { TicketCreationRequestControlService } from 'src/app/shared/services/ticket-creation-request-control.service';
import { CIFDatadogService } from 'src/app/shared/services/cif-datadog';
import { getMediaType } from 'src/app/utils/cxone-utils';
import { MediaType } from 'src/app/utils/media-type';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';

@Component({
  selector: 'app-civics-v2',
  standalone: true,
  imports: [],
  templateUrl: './civics-v2.component.html',
  styleUrl: './civics-v2.component.css',
})
export class CivicsV2Component {
  private destroy$ = new Subject<void>();
  private channelProviderVariables: TemplateValuesChannelProvider | null = null;
  private channelProviderVariablesObj: TemplateValuesChannelProviders | null =
    null;
  private isReloadedSession = false;
  private pendingPopUrls = new Map<string, CXonePopUrl>();
  private activeSessionsIds: string[] = [];
  private sessionEnded: { contactId: string; templateAusente: string }[] = [];

  constructor(
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private sdkDigital: SdkDigitalService,
    private logger: LoggerService,
    private loginService: LoginService,
    private dynamics: DynamicsCivicsV2Service,
    private eventHandler: EventHandlerService,
    private sendReloadScreenSignalService: SendReloadScreenSignalService,
    private mainService: ContactCenterMainService,
    private ticketCreationRequestControlService: TicketCreationRequestControlService,
    private cifDatadogService: CIFDatadogService,
    private localStorageUtils: LocalStorageUtils,
    private jsonConverterUtils: JsonConverterUtils,
  ) {
    this.isReloadedSession = sendReloadScreenSignalService.interactionIdExist();
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    this.sendReloadScreenSignalService.sendReloadSignal();
    event.preventDefault();
    event.returnValue = '';
  }

  async ngOnInit() {
    this.logger.info('CIVICS-V2 - inicializado');
    const centralId =
      this.localStorageUtils.safeGetItem('centralId') || 'civics-v2';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );
      if (isAuthenticated) {
        this.logger.info('CIVICS-V2 - Usuário autenticado com sucesso.');
        await this.inicializarEventosCXone();
        this.sdkAcdAgent.instance.screenPop.screenPopSubscribe(
          true,
          true,
          true,
          true,
          true,
          true,
        );

        this.channelProviderVariables =
          await this.dynamics.loadTemplateValues();

        this.logger.info(
          'CIVICS-V2 - Channel Provider Variables: ',
          JSON.stringify(this.channelProviderVariables, null, 2),
        );

        if (!this.channelProviderVariables) {
          this.logger.error(
            'CIVICS-V2 - Erro ao carregar environment do CIFramework',
            JSON.stringify(this.channelProviderVariables, null, 2),
          );
        }

        /** ##### INCIO EVENTO DIGITAL CIVICS ##### CIVICS V2 **/
        this.sdkDigital.onDigitalContactEvent$.subscribe(
          async (digitalContact: CXoneDigitalContact) => {
            this.logger.info(
              `CIVICS-V2 - NICE Event Details: ${JSON.stringify(digitalContact.eventDetails)}`,
            );

            if (digitalContact.eventDetails.eventType === 'CaseInboxAssigned') {
              this.logger.info(
                'CIVICS-V2 - Evento digital recebido: ',
                JSON.stringify(digitalContact.case),
              );

              this.processDigitalCreateEvent(digitalContact);
            }

            if (
              digitalContact.eventDetails.eventType === 'CaseInboxUnassigned'
            ) {
              this.processDigitalEndedEvent(digitalContact);
            }
          },
        );

        this.sdkAcdAgent.instance.screenPop.popUrlSubject.subscribe(
          async (popUrlData) => {
            this.logger.info(
              'CIVICS-V2 - Screen popUrl recebido: ',
              JSON.stringify(popUrlData),
            );
            this.DigitalAttachDataEventHandler(popUrlData);
          },
        );

        /** ##### FIM EVENTO DIGITAL CIVICS V2 ##### **/

        this.logger.info(
          'DYNAMICS - terminando de adicionar Handler de session switch',
        );

        var input = {
          templateName: this.channelProviderVariables?.templateSessaoPadrao,
          templateParameters: {},
          context: {
            sessaobetta: true,
          },
        };

        await this.dynamics.cifCreateSession(input, null, '');

        this.sdkAcdAgent.agentState$
          .pipe(takeUntil(this.destroy$))
          .subscribe((agentState) => {
            this.logger.info(
              `CIVICS-V2 (ACD) - Agent State | currentState: ${agentState.currentState.state} | nextState: ${agentState.nextState.state}`,
            );
          });

        /**
         * Evento de atualização do contato de voz
         */
        this.sdkAcdAgent.voiceContactUpdate$
          .pipe(takeUntil(this.destroy$))
          .subscribe(async (voiceContact: CXoneVoiceContact) => {
            const status = voiceContact.status || '';
            const contactId = voiceContact.contactID || '';
            const contatoEvento = { id: contactId, status: status };
            const skillName = voiceContact.skillName || '';
            const contact = voiceContact.isInbound ? 'INBOUND' : 'OUTBOUND';
            const callType = voiceContact.callType || '';
            const screenPopUrl = voiceContact.screenPopUrl || '';
            let eventoProcessado = this.eventHandler.isProcessed(contatoEvento);
            const logStringAgent = `Contato: ${contact} | Status: ${status} | ContactID: ${contactId} | skillName: ${skillName} | callType: ${callType} | eventoProcessado: ${eventoProcessado} `;

            this.logger.info(
              'CIVICS-V2 - iframe debug: isproccesed',
              eventoProcessado,
            );
            this.logger.info(
              `CIVICS-V2 (ACD - Evento Geral - ${logStringAgent}): `,
              voiceContact,
            );

            if (
              status === VoiceContactStatusAgent.ACTIVE &&
              !eventoProcessado
            ) {
              this.logger.info(
                `CIVICS-V2 (ACD - ${logStringAgent} | screenPopUrl: ${screenPopUrl}) | Iniciando atendimento.`,
              );
              this.eventHandler.add(contatoEvento);
              await this.processVoiceContactEvent(voiceContact, logStringAgent);
            }

            if (status === VoiceContactStatusAgent.DISCONNECTED) {
              this.eventHandler.remove(contatoEvento);
              const sessionId = this.localStorageUtils.safeGetItem(
                voiceContact.contactID,
              );

              if (!sessionId) {
                this.logger.info(
                  `CIVICS-V2 (ACD - ${logStringAgent}) | sessionId não encontrado no localStorage, não é possível encerrar: ${voiceContact.contactID}`,
                );
                return;
              }

              var context = {
                itau_cliente_on: false,
                itau_sessao_ativa: false,
              };

              this.logger.info(
                `CIVICS-V2 (ACD - ${logStringAgent}) - encerrando sessão: ${sessionId}`,
              );

              if (this.isReloadedSession === true) {
                this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
                this.isReloadedSession = false;
              } else {
                await this.dynamics
                  .cifCloseSession(
                    this.channelProviderVariables?.templateAusente ?? '',
                    context,
                    sessionId,
                    voiceContact.contactID,
                    'voice',
                  )
                  .finally(() => {
                    this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
                  });
              }

              this.logger.info(
                `CIVICS-V2 (ACD - ${logStringAgent}) - Contato desconectado ou transferido`,
              );
            }
          });

        /**
         * Evento de atualização do agent leg
         */
        this.sdkAcdAgent.agentLegEvent$
          .pipe(takeUntil(this.destroy$))
          .subscribe(async (agentLegUpdate) => {
            CXoneVoiceClient.instance.handleAgentLegEvent(agentLegUpdate);
            if (agentLegUpdate.status === 'Dialing') {
              CXoneVoiceClient.instance.connectAgentLeg(
                agentLegUpdate.agentLegId,
              );
            }
          });

        /**
         * Evento de mudança de estado da sessão do agente
         */
        this.sdkAcdAgent.sessionState$
          .pipe(takeUntil(this.destroy$))
          .subscribe(async (agentSessionChange) => {
            switch (agentSessionChange.status) {
              case AgentSessionStatus.JOIN_SESSION_SUCCESS:
              case AgentSessionStatus.SESSION_START: {
                this.logger.info(
                  'CIVICS-V2 - Agent session started successfully.....',
                );
                // await this.initWebRTC();
                break;
              }
              case AgentSessionStatus.SESSION_END: {
                this.logger.info(
                  'CIVICS-V2 - Agent session ended successfully.....',
                );
                break;
              }
              case AgentSessionStatus.JOIN_SESSION_FAILURE:
                this.logger.info('CIVICS-V2 - Agent session join failed.....');
                break;
            }
          });
      } else {
        this.logger.warn('CIVICS-V2 - Falha na autenticação do usuário.');
      }
    } catch (error) {
      if (error instanceof Error && error.message) {
        this.logger.error(error);
      } else {
        this.logger.error('CIVICS-V2 - Erro ao iniciar o componente: ', error);
      }
    }
  }

  /**
   * Método para inicializar eventos CXone
   */
  private async inicializarEventosCXone() {
    this.logger.info('CIVICS-V2 - Inicializando eventos CXone...');
    await this.niceSdkAuthService.launchAgent();
    await this.sdkAcdAgent.initialize();
    await this.sdkDigital.initializeEvents();
    await this.dynamics.initialize(environment.cif_versao2_civics_v2);
    this.logger.info('CIVICS-V2 - Eventos CXone inicializados.');
  }

  private async getChannelProviderTemplateValues() {
    const templateChannelProvider = {};
    return templateChannelProvider;
  }

  private async processVoiceContactEvent(
    voiceContact: CXoneVoiceContact,
    logStringAgent: string,
  ): Promise<void> {
    try {
      if (typeof (window as any).Microsoft !== 'undefined') {
        const attachdata = this.deserializeScreenPopUrl(
          voiceContact.screenPopUrl,
        );

        this.logger.info(
          `CIVICS-V2 (ACD - ${logStringAgent}) - attachdata deserializado: ${JSON.stringify(attachdata)}`,
        );

        if (!voiceContact.isInbound && !attachdata.callback) {
          this.logger.info(
            `CIVICS-V2 (ACD - ${logStringAgent}) - Contato não é inbound, não executando a criação de ticket no dynamics`,
          );
          return;
        }

        var datacb: any = {};
        datacb['itau_name'] = attachdata.itau_name;
        datacb['itau_mst_attachdata'] = JSON.stringify(attachdata.u_json);
        datacb['itau_u_lk_projeto@odata.bind'] = attachdata.itau_u_lk;
        datacb['itau_u_nomeprojeto'] = attachdata.itau_u_nomeprojeto;
        datacb['itau_st_id_conexao'] = voiceContact.contactID;
        datacb[
          attachdata.fieldnegocio ?? this.channelProviderVariables?.fieldNegocio
        ] = attachdata.itau_name;
        // datacb[attachdata.fieldnegocio ?? this.channelProviderVariables?.fieldNegocio] =
        //   attachdata.itau_u_nomeprojeto;

        this.logger.info(
          `CIVICS-V2 (ACD - ${logStringAgent}) - Dados do ticket a serem criados: ${JSON.stringify(datacb)}`,
        );

        // faz a criação do ticket
        const result = await this.dynamics.cifCreateTicket(
          datacb,
          attachdata.retrieverecordcol,
          attachdata.retrieverecordtable,
          voiceContact.contactID,
          'voice',
          attachdata,
        );

        if (!result || !result.id_interacao || !result.id_ticket) {
          this.logger.error(
            `CIVICS-V2 (ACD - ${logStringAgent}) - Erro ao criar ticket: ${JSON.stringify(result)}`,
          );
          return;
        }

        let input_atendimento = {
          templateName:
            attachdata.templatecreatesession ??
            this.channelProviderVariables?.templateCreateSession,
          templateParameters: {
            id_interacao: result.id_interacao,
            id_ticket: result.id_ticket,
          },
        };
        this.logger.info(
          `CIVICS-V2 (ACD - ${logStringAgent}) - Criando sessão: ${JSON.stringify(input_atendimento)}`,
        );

        // abre uma aba com o ticket que foi aberto e salva o sessionId no localStorage
        const sessionId = await this.dynamics.cifCreateSession(
          input_atendimento,
          'voice',
          voiceContact.contactID,
        );
        this.localStorageUtils.safeSetItem(voiceContact.contactID, sessionId);
        this.localStorageUtils.safeSetItem(sessionId, voiceContact.contactID);

        this.sendReloadScreenSignalService.setInteractionIdInLocalStorage(
          voiceContact.contactID,
        );

        this.logger.info(
          `CIVICS-V2 (ACD - ${logStringAgent}) - função de criação de ticket executada com sucesso: ${JSON.stringify(result)}`,
        );
      } else {
        this.logger.warn(
          'CIVICS-V2 - Função microsoft.Microsoft.Cif ainda não está disponível.',
        );
      }
    } catch (error) {
      this.eventHandler.remove({ id: voiceContact.contactID, status: '' });
      this.logger.error(
        `CIVICS-V2 (ACD - ${logStringAgent}) - Erro ao processar contato de voz: ${error}`,
      );
    }
  }

  /** ##### MÉTODOS DE PROCESSAMENTO DO DIGITAL CIVICS V2 ##### */
  private async DigitalAttachDataEventHandler(popUrl: CXonePopUrl) {
    this.logger.info('CIVICS-V2 - tabTitle: ', popUrl.tabTitle?.toUpperCase());
    this.logger.info('CIVICS-V2 - contact ID: ', popUrl.contactId);

    if (popUrl.tabTitle?.toUpperCase() === 'ATTACHESDYNAMICS') {
      this.pendingPopUrls.set(popUrl.contactId, popUrl);
      this.logger.info(
        'CIVICS-V2 - Attachdata armazenado para contato digital: ',
        popUrl.contactId,
      );
    }

    if (popUrl.tabTitle?.toUpperCase() === 'FOCUS') {
      const dynamicsSessionData = this.localStorageUtils.safeGetItem(
        `sessionRelationship-${popUrl.contactId}`,
      );

      if (dynamicsSessionData === null) return;

      let parsedData: {
        dynamicsSessionId: string;
        dynamicsinteractionId: string;
      } = {
        dynamicsSessionId: '',
        dynamicsinteractionId: '',
      };

      parsedData = this.jsonConverterUtils.JsonParsed(dynamicsSessionData);

      const sessionRelationship = parsedData;

      this.logger.info(
        'CIVICS-V2 - Solicitação de foco recebida: ',
        JSON.stringify(dynamicsSessionData),
      );

      this.logger.info(
        'CIVICS-V2 - Chamando raise event alterarSessao com os valores: ',
        sessionRelationship,
      );

      await (window as any).Microsoft.CIFramework.raiseEvent('alterarSessao', {
        sessionId: sessionRelationship.dynamicsSessionId,
        correlationId: sessionRelationship.dynamicsinteractionId,
      });
    }
  }

  private async processDigitalCreateEvent(digitalContact: CXoneDigitalContact) {
    try {
      let channel = '';
      let caseId = '';
      let popUrl: any = '';
      let isPopUrl = false;

      if (!digitalContact) {
        this.logger.error(
          'CIVICS-V2 - Evento principal digitalContact não recebido',
        );
        throw new Error('DIGITAL_CONTACT_NULL');
      }

      //Recebendo o valor do caseId
      caseId = digitalContact.caseId;
      this.logger.info(
        'CIVICS-V2 - ContactId do evento digital recebido: ',
        caseId,
      );

      //const ujson = await this.generatePopUrlFronDigitalContact(digitalContact);
      const ujson = await this.mainService.generatePopUrlFronDigitalContact(
        digitalContact,
        'CIVICS-V2',
      );

      if (!ujson) {
        this.logger.warn(
          'CIVICS-V2 - Dados não obtidos da extração do digitalEvent.',
        );
        isPopUrl = true;
      } else {
        popUrl = ujson.popUrl;
        channel = ujson.channel;
      }

      //Obtendo o Object Channel Providers Variables
      await this.mainService
        .loadTemplateValues(channel)
        .then((obj) => {
          this.channelProviderVariablesObj = obj;

          if (!obj) {
            this.logger.error(
              'CIVICS-V2 - Channel provider nulo, ',
              JSON.stringify(obj, null, 2),
            );
          }

          this.logger.info(
            'CIVICS-V2 - Channel provider variables object: ',
            JSON.stringify(obj, null, 2),
          );
        })
        .catch((error) => {
          this.logger.error(
            'CIVICS-V2 - Erro ao carregar o object channel provider variables, ',
            error,
          );
        });

      if (isPopUrl) {
        popUrl = await this.handleFallbackPopUrl(digitalContact.caseId);
      }

      this.logger.info(
        'CIVICS-V2 - Iniciando a criação do ticket, ',
        JSON.stringify(popUrl),
      );
      await this.DigitalContactCaseAssignedHandler(
        popUrl,
        isPopUrl,
        getMediaType(digitalContact),
      );
    } catch (error) {
      this.logger.error(
        '- CIVICS-V2 - Erro ao processar contato de digital: ',
        error,
      );
    }
  }

  private async processDigitalEndedEvent(digitalEvent: CXoneDigitalContact) {
    const sessionRelationship = this.localStorageUtils.safeGetItem(
      `sessionRelationship-${digitalEvent.caseId}`,
    );

    this.logger.info(
      'CIVICS-V2 - Dados de encerramento recebebidos do local storage: ',
      JSON.stringify(sessionRelationship),
    );

    //Localizando o template de encerramento
    const templateEnded = this.sessionEnded.find(
      (e) => e.contactId === digitalEvent.caseId,
    );

    this.logger.info(
      'CIVICS-V2 - Parametros de encerramento de ticket: ',
      JSON.stringify(templateEnded),
    );
    this.logger.info(
      'CIVICS-V2 - Template de encerramento CIVICS: ',
      templateEnded?.templateAusente,
    );

    //remover contactId do array de controle de abas
    this.logger.info(
      'CIVICS-V2 - Remover da lista o contactId: ',
      digitalEvent.caseId,
    );
    this.activeSessionsIds = this.activeSessionsIds.filter(
      (id) => id !== digitalEvent.caseId,
    );

    if (sessionRelationship != null) {
      let sessionRelationshipJSON =
        this.jsonConverterUtils.JsonParsed(sessionRelationship);
      const sessionId = sessionRelationshipJSON.dynamicsSessionId;

      const context = {
        itau_cliente_on: false,
        itau_sessao_ativa: false,
      };

      this.logger.info('CIVICS-V2 - Encerrando sessão', sessionId);

      try {
        const updateResult = await (
          window as any
        ).Microsoft.CIFramework.updateContext(context, sessionId);

        const input = {
          templateName: templateEnded?.templateAusente,
          templateParameters: {},
        };

        const idInteracao = updateResult?.id_interacao;

        if (!sessionId || !idInteracao) {
          this.logger.warn(
            'CIVICS-V2 - sessionId ou idInteracao ausentes, não é possível fechar a sessão.',
          );
          return;
        }

        await (window as any).Microsoft.CIFramework.notifyEvent(input);

        // Chama a função para motivar o encerramento com o id da interação
        const eventInputParameters = {
          sessionId: sessionId,
          correlationId: idInteracao,
        };

        await (window as any).Microsoft.CIFramework.raiseEvent(
          'fecharSessao',
          eventInputParameters,
        );

        //Limpar o item do array após o encerramento da sessão
        this.logger.info(
          'CIVICS-V2 - Remover template de encerramento da lista: ',
          JSON.stringify(templateEnded),
        );
        this.logger.info(
          'CIVICS-V2 - Resultado antes da remoção: ',
          JSON.stringify(this.sessionEnded),
        );
        this.sessionEnded = this.sessionEnded.filter(
          (id) => id.contactId !== digitalEvent.caseId,
        );
        this.logger.info(
          'CIVICS-V2 - Resultado após a remoção: ',
          JSON.stringify(this.sessionEnded),
        );

        this.logger.info('CIVICS-V2 - sessão fechada com sucesso', sessionId);
      } catch (error) {
        this.logger.error(
          'CIVICS-V2 - Erro ao fechar sessão: ',
          error,
          'sessionId:',
          sessionId,
        );
        throw error;
      }
    }
  }

  private async DigitalContactCaseAssignedHandler(
    popUrl: any,
    isPopUrl: boolean,
    mediaType: MediaType,
  ) {
    let attachdata: any = {};
    let contactId = '';

    if (isPopUrl === true) {
      attachdata = this.deserializeScreenPopUrl(popUrl);
      contactId = popUrl.caseId;
    } else {
      const popUrlData = JSON.stringify(popUrl);
      attachdata = this.jsonConverterUtils.JsonParsed(popUrlData);
      contactId = attachdata['contactId'];
    }

    this.logger.info(
      `CIVICS-V2 - attachdata deserializado: ${JSON.stringify(attachdata)}`,
    );

    //Inserindo template ausente para encerramento da sessão digital, somente CIVICS
    this.sessionEnded.push({
      contactId: contactId,
      templateAusente:
        this.channelProviderVariablesObj?.templateAusente ??
        attachdata.templateausente,
    });
    this.logger.info(
      'CIVICS-V2 - Sessão de encerramento armazenada: ',
      this.sessionEnded,
    );

    //Inserindo contactId no array utilizado para alternância de abas, somente CIVICS
    this.logger.info('CIVICS-V2 - Inserir na lista contactId: ', contactId);
    this.activeSessionsIds.push(contactId);
    this.logger.info(
      'CIVICS-V2 - ContactId contidos na lista : ',
      this.activeSessionsIds,
    );

    const ticketHasRequest =
      this.ticketCreationRequestControlService.checkTicketRequest(contactId);

    if (ticketHasRequest === true) {
      this.logger.warn(
        `CIVICS-V2 - Já existe ticket aberto com os dados solicitados, ${contactId}`,
      );
      this.cifDatadogService.openTicket.request.duplicated({
        masterId: contactId,
        attachData: attachdata,
        mediaType,
      });
      return;
    }

    this.ticketCreationRequestControlService.saveTicketRequest(contactId);

    var datacb: any = {};
    datacb['itau_name'] =
      this.channelProviderVariablesObj?.itau_name ?? attachdata.itau_name;
    datacb['itau_mst_attachdata'] =
      isPopUrl === false
        ? JSON.stringify(attachdata['u_json'])
        : JSON.stringify(attachdata.u_json);
    datacb['itau_u_lk_projeto@odata.bind'] =
      this.channelProviderVariablesObj?.itau_u_lk ?? attachdata.itau_u_lk;
    datacb['itau_u_nomeprojeto'] =
      this.channelProviderVariablesObj?.itau_u_nomeprojeto ??
      attachdata.itau_u_nomeprojeto;
    datacb['itau_st_id_conexao'] = contactId;
    datacb[
      this.channelProviderVariablesObj?.fieldNegocio
        ? this.channelProviderVariables?.fieldNegocio
        : attachdata.fieldNegocio
    ] = this.channelProviderVariablesObj?.itau_name ?? attachdata.itau_name;
    //datacb[this.channelProviderVariablesObj?.triggerPlugin ?? 'triggerPlugin'] = this.channelProviderVariablesObj?.itau_u_nomeprojeto ?? attachdata.itau_u_nomeprojeto;

    this.logger.info(
      'CIVICS-V2 - Dados do ticket a serem criados: ',
      JSON.stringify(datacb),
    );

    const result = await this.dynamics.cifCreateTicket(
      datacb,
      this.channelProviderVariablesObj?.retrieveRecordCol
        ? this.channelProviderVariables?.retrieveRecordCol
        : attachdata.retrieverecordcol,
      this.channelProviderVariablesObj?.retrieveRecordTable
        ? this.channelProviderVariables?.retrieveRecordTable
        : attachdata.retrieverecordtable,
      contactId,
      mediaType,
      attachdata.U_JSON,
    );

    if (!result || !result.id_interacao || !result.id_ticket) {
      this.logger.error(
        `CIVICS-V2 - Erro ao criar ticket: ${JSON.stringify(result)}`,
      );
      return;
    }

    var input: any = {};
    input['templateName'] = this.channelProviderVariablesObj
      ?.templateCreateSession
      ? this.channelProviderVariables?.templateCreateSession
      : attachdata.templateCreateSession;
    input['templateParameters'] = {
      id_interacao: result.id_interacao,
      id_ticket: result.id_ticket,
      cliente_on: true,
    };
    input['isFocused'] = this.activeSessionsIds.length > 1 ? false : true; //Se for a primeira interação ele força o focus da aba, se for a partir da segunda interação ele no força o focus da aba.

    this.logger.info(`CIVICS-V2 - Criando sessão: ${JSON.stringify(input)}`);

    const sessionId = await this.dynamics.cifCreateSession(
      input,
      mediaType,
      contactId,
    );

    var sessionData: any = {};
    sessionData['contactCenterInteractionId'] = contactId;
    sessionData['dynamicsSessionId'] = sessionId;
    sessionData['dynamicsinteractionId'] = result.id_interacao;
    sessionData['dynamicsTicketId'] = result.id_ticket;

    this.localStorageUtils.safeSetItem(
      `sessionRelationship-${sessionData.contactCenterInteractionId}`,
      JSON.stringify(sessionData),
    );

    //Se já tiver uma aba aberta no dynamics, o método insere uma marcação na nova aba para informar ao operador que chegou uma nova interação. Somente CIVICS
    if (this.activeSessionsIds.length > 1) {
      await (window as any).Microsoft.CIFramework.requestFocusSession(
        sessionId,
        result.id_interacao,
      );
    }

    this.logger.info(
      'CIVICS-V2 - Fluxo de abertura de ticket executado com sucesso',
      result,
    );
  }
  /** ##### FIM MÉTODOS DE PROCESSAMENTO DO DIGITAL CIVICS V2 ##### **/

  deserializeScreenPopUrl(screenPopUrl: string) {
    const objeto: any = {};

    // prettier-ignore
    screenPopUrl = screenPopUrl.replaceAll("'", "\"");

    const pares = screenPopUrl.split('|');

    pares.forEach((par) => {
      const idx = par.indexOf(':');
      if (idx > -1) {
        const chave = par.substring(0, idx);
        const valor = par.substring(idx + 1);
        if (chave) {
          try {
            objeto[chave.toLowerCase()] = JSON.parse(valor);
          } catch (e) {
            objeto[chave.toLowerCase()] = valor;
          }
        }
      }
    });

    return objeto;
  }

  private async handleFallbackPopUrl(caseId: string) {
    let popUrl = '';

    this.logger.info('CIVICS-V2 - Iniciando busca pelo evento de popUrl');

    for (let tentativa = 1; tentativa <= 10; tentativa++) {
      this.logger.info(`CIVICS-V2 - Tentativa ${tentativa} de 10.`);

      popUrl = this.pendingPopUrls.get(caseId)?.url ?? '';

      if (popUrl) {
        this.logger.info('CIVICS-V2 - PopUrl encontrado:', caseId);
        break;
      }

      this.logger.warn('CIVICS-V2 - PopUrl não encontrado:', caseId);

      await CxOneUtils.Delay(1000);
    }

    return popUrl;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
